import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, throwError, of } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AdvisorService {

 
  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  advisor(): Observable<any> {
    return this.http.get(`${environment.api_URL}/advisor?page=1&limit=20`)
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            console.warn('Advisor request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  getAdvisor(id:any): Observable<any> {
    return this.http.get(`${environment.api_URL}/advisor/${id}`)
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            console.warn('Advisor request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  addAdvisor(data:any): Observable<any> {
    return this.http.post(`${environment.api_URL}/advisor`,data)
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            console.warn('Advisor request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          
          // Log error for debugging
          console.error('Advisor error:', error);
          
          // Return a structured error response
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  updateAdvisor(id:string,data:any): Observable<any> {
    return this.http.patch(`${environment.api_URL}/advisor/${id}`,data)
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            console.warn('Advisor request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          
          // Log error for debugging
          console.error('Advisor error:', error);
          
          // Return a structured error response
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  deleteAdvisor(id: string): Observable<any> {
    return this.http.delete(`${environment.api_URL}/advisor/${id}`);
  }
  assignAdvisor(data:any): Observable<any> {
    return this.http.patch(`${environment.api_URL}/auth/assign-advisor`, data).pipe(
      retry(1),
      catchError((error: HttpErrorResponse) => {
        if (!isPlatformBrowser(this.platformId)) {
          return of({ status: false, message: 'SSR execution ignored' });
        }

        const handledError = {
          status: false,
          message: this.getErrorMessage(error),
          details: error.error?.message || null, // Captures NestJS validation arrays
          code: error.status
        };

        return throwError(() => handledError);
      })
    );
  }
  addAdvisorImg(data:any): Observable<any> {
    return this.http.patch(`${environment.api_URL}/advisor/${data?.id}/images?type=${data?.type}`,data.files)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          if (!isPlatformBrowser(this.platformId)) {
            console.warn('Advisor request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
 getAssigendProperty(data:any){
  return this.http.post(`${environment.api_URL}/property/assigendProperty`,data)
  .pipe(
    retry(1), // Retry once on failure
    catchError((error: HttpErrorResponse) => {
      // Handle server-side rendering gracefully
      if (!isPlatformBrowser(this.platformId)) {
        console.warn('Advisor request during SSR, returning empty response');
        return of({ status: false, message: 'SSR mode' });
      }
      
      // Log error for debugging
      console.error('Advisor error:', error);
      
      // Return a structured error response
      return throwError(() => ({
        status: false,
        message: this.getErrorMessage(error),
        error: error
      }));
    })
  );
 }

  private getErrorMessage(error: HttpErrorResponse): string {
    if (error.status === 0) {
      return 'Network error. Please check your connection.';
    } else if (error.status === 401) {
      return 'Invalid credentials.';
    } else if (error.status === 403) {
      return 'Access denied.';
    } else if (error.status >= 500) {
      return 'Server error. Please try again later.';
    } else {
      return 'Advisor failed. Please try again.';
    }
  }
}
